import React from "react";
import { Modal } from "antd";

const AddonRepeatModal = ({
  open,
  visible,
  onRepeat,
  onCustomize,
  onClose,
  repeatDisabled,
}) => {
  const isOpen = open ?? visible;
  return (
    <Modal
      open={isOpen}
      footer={null}
      closable={false}
      centered
      width={420}
      style={{
        textAlign: "center",
      }}
      styles={{ body: {
        padding: "20px",
      } }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "12px",
        }}
      >
        <p
          style={{
            margin: 0,
            fontSize: "1.4em",
            fontWeight: 600,
            color: "#0F0718",
          }}
        >
          Item has Add-ons
        </p>
        <p
          style={{
            margin: "4px 0 12px 0",
            fontSize: "1em",
            fontWeight: 400,
            color: "rgba(15,7,24,0.7)",
            textAlign: "center",
            lineHeight: "1.4em",
          }}
        >
          Would you like to repeat the same add-on or customize the add-ons for this additional unit?
        </p>
        <div
          style={{
            width: "100%",
            borderRadius: "8px",
            border: "1px solid #E5E5E5",
            padding: "12px",
            cursor: repeatDisabled ? "not-allowed" : "pointer",
            textAlign: "left",
            opacity: repeatDisabled ? 0.5 : 1,
            backgroundColor: repeatDisabled ? "#f5f5f5" : "#ffffff",
          }}
          onClick={() => {
            if (!repeatDisabled) {
              onRepeat();
            }
          }}
        >
          <p style={{ margin: 0, fontWeight: 600, color: "#0F0718" }}>Repeat</p>
          <p style={{ margin: "4px 0", fontSize: "0.95em", color: "rgba(15,7,24,0.7)" }}>Use the same add-ons for this additional unit</p>
        </div>

        <div
          style={{
            width: "100%",
            borderRadius: "8px",
            border: "1px solid #E5E5E5",
            padding: "12px",
            cursor: "pointer",
            textAlign: "left",
          }}
          onClick={onCustomize}
        >
          <p style={{ margin: 0, fontWeight: 600, color: "#0F0718" }}>Customize</p>
          <p style={{ margin: "4px 0", fontSize: "0.95em", color: "rgba(15,7,24,0.7)" }}>Select different add-ons for this additional unit</p>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            width: "100%",
            marginTop: "16px",
          }}
        >
          <button
            onClick={onClose}
            style={{
              padding: "6px 16px",
              borderRadius: "6px",
              border: "1px solid #D9D9D9",
              backgroundColor: "#FFFFFF",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default AddonRepeatModal;
